import React from 'react'
import './style/footer.css'

function Footer() {
    return (
        <div className="footer">
             <p> &#xa9; Designed By <a href="https://www.linkedin.com/in/ritika-dey/" target="_blank">
             <b>Ritika Dey</b></a> 2021 </p>
        </div>
    )
}

export default Footer
